import { Typography, toCurrencyString, CurrencyCode } from '@client/toolkit';
import { ChangePercentage } from './change-percentage';
import { MetricCard } from './metric-card';
import { MoneyDto } from '@client/api';

export function OutstandingValueCard({
  title,
  amount,
  showChange = false,
  changeValue,
  isInverted,
  prefix,
  isLoading = false,
}: {
  title: string;
  amount?: MoneyDto;
  showChange?: boolean;
  changeValue?: number;
  isInverted?: boolean;
  prefix?: string;
  isLoading?: boolean;
}) {
  return (
    <MetricCard title={title} isLoading={isLoading}>
      <span className="flex items-center gap-2">
        <Typography variantFontSize="h2">
          {prefix}
          {toCurrencyString(amount?.value, undefined, {
            currency: amount?.currency as CurrencyCode,
            minimumFractionDigits: 0,
            maximumFractionDigits:0
           })}
        </Typography>
        {showChange && changeValue !== undefined && (
          <ChangePercentage value={changeValue} size="2xl" isInverted={isInverted} />
        )}
      </span>
    </MetricCard>
  );
}
